var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Edit/Delete/"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33317 7.41658C8.60931 7.41658 8.83317 7.64043 8.83317 7.91658V14.1666C8.83317 14.4427 8.60931 14.6666 8.33317 14.6666C8.05703 14.6666 7.83317 14.4427 7.83317 14.1666L7.83317 7.91658C7.83317 7.64043 8.05703 7.41658 8.33317 7.41658Z",
    fill: "#5B5C5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1665 7.91658C12.1665 7.64043 11.9426 7.41658 11.6665 7.41658C11.3904 7.41658 11.1665 7.64043 11.1665 7.91658V14.1666C11.1665 14.4427 11.3904 14.6666 11.6665 14.6666C11.9426 14.6666 12.1665 14.4427 12.1665 14.1666V7.91658Z",
    fill: "#5B5C5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08325 2.91666C7.08325 2.2263 7.6429 1.66666 8.33325 1.66666H11.6666C12.3569 1.66666 12.9166 2.2263 12.9166 2.91666V4.00003L16.1666 4.00003C16.4427 4.00003 16.6666 4.22389 16.6666 4.50003C16.6666 4.77617 16.4427 5.00003 16.1666 5.00003H15.8333V15.6667C15.8333 17.0474 14.714 18.1667 13.3333 18.1667H6.66659C5.28587 18.1667 4.16659 17.0474 4.16659 15.6667V5.00003H3.83325C3.55711 5.00003 3.33325 4.77617 3.33325 4.50003C3.33325 4.22389 3.55711 4.00003 3.83325 4.00003H7.08325V2.91666ZM8.33325 2.66666H11.6666C11.8047 2.66666 11.9166 2.77859 11.9166 2.91666V3.99999H8.08325V2.91666C8.08325 2.77859 8.19518 2.66666 8.33325 2.66666ZM5.16659 5.00003H14.8333V15.6667C14.8333 16.4951 14.1617 17.1667 13.3333 17.1667H6.66659C5.83816 17.1667 5.16659 16.4951 5.16659 15.6667V5.00003Z",
    fill: "#5B5C5B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.b989006110812374dc9614f788ebbaa3.svg";
export { ForwardRef as ReactComponent };